import { ApolloClient, InMemoryCache } from '@apollo/client';
import getLink from './get-link';

const isBrowser = typeof window !== 'undefined';
const linkOptions = {
  fetch: !isBrowser ? fetch : undefined
};

function createApolloClient(options) {
  const {
    resolvers,
    initialState = {},
    possibleTypes,
    typePolicyQueryFields = {},
    addTypename = true
  } = options;
  const cache = new InMemoryCache({
    addTypename,
    possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          ...typePolicyQueryFields,
          getEntitySchema: {
            read(_, { args, toReference }) {
              return toReference({
                __typename: 'DataEntitySchemaDefinition',
                id: args.id
              });
            }
          }
        }
      }
    }
  }).restore(initialState);
  const link = getLink({ ...options, linkOptions });

  return new ApolloClient({
    connectToDevTools: isBrowser && process.env.NODE_ENV !== 'production',
    ssrMode: !isBrowser, // Disables forceFetch on the server (so queries are only run once)
    resolvers,
    cache,
    link
  });
}

export default createApolloClient;
